import { translate } from 'utils/translation';

export const documentSection = (index, title, elements) => ({
  index: index || 0,
  sectionType: 'DOCUMENT_SECTION',
  format: null,
  title: title || translate('common.documents'),
  backgroundImage: null,
  elements: elements || []
});